module.exports = __webpack_public_path__ + "img/about2.49757c09.png";